import { Link } from '@tanstack/react-router'
import { ArrowLeftIcon, CompassIcon } from 'lucide-react'

import { BrandWordmark } from '@/components/brand-mark'
import { Button } from '@/components/ui/button'

export function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center">
      <BrandWordmark />
      <div className="flex size-14 items-center justify-center rounded-2xl bg-brand-subtle text-primary">
        <CompassIcon className="size-7" />
      </div>
      <div className="space-y-2">
        <p className="font-key text-xs tracking-widest text-muted-foreground uppercase">
          Erreur 404
        </p>
        <h1 className="text-2xl font-semibold tracking-tight">Page introuvable</h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          Cette adresse n’existe pas ou la ressource a été supprimée.
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to="/">
          <ArrowLeftIcon />
          Retour à l’accueil
        </Link>
      </Button>
    </div>
  )
}
